export default class Schedule {
  checkbox_calendar(target, elm_date, elm_time) {
    if ($(target).is(':checked')) {
      $(elm_date).prop('disabled', false)
      $(elm_time).prop('disabled', false)

      addDatepicker(elm_date)
      setDefaultDate(elm_date)
      addTimepicker(elm_time)
      $(elm_date).attr('readOnly', true)
      $(elm_time).attr('readOnly', true)
    } else {
      $(elm_date).prop('disabled', true)
      $(elm_time).prop('disabled', true)
    }
  }

  select_template_send_again(cb_send_again) {
    if ($(cb_send_again).is(':checked')) {
      $('#content_send_again').removeClass('hidden')
    } else {
      $('#content_send_again').addClass('hidden')
    }
  }

  setTextToCurrentPos() {
    var curPos = document.getElementById('message_body2').selectionEnd
    let vl_text_area = $('#message_body2').val()
    let text_to_insert = $('#message_body').val()

    $('#message_body2').val(vl_text_area.slice(0, curPos) + text_to_insert + vl_text_area.slice(curPos))

    if (!$('#message_subject2').data('overwrite')) {
      let text_overwrite = $('#message_subject').val()
      $('#message_subject2').val(text_overwrite)
    }
  }

  showModalConfirm(cb_send, action, method) {
    if (!method) return

    if (method == 'delete' && !$(cb_send).is(':checked') && action == 'edit') {
      let cb_send_again = $('#message_schedule_again').is(':checked')

      $('#message_schedule_again').prop('checked', false)
      $('#message_schedule_again_date').prop('disabled', true)
      $('#message_schedule_again_time').prop('disabled', true)

      $(confirmModal).modal('show')

      $(confirmModal).on('hidden.bs.modal', function () {
        if (cb_send_again) {
          $('#message_schedule_again').prop('checked', true)
          $('#message_schedule_again_date').prop('disabled', false)
          $('#message_schedule_again_time').prop('disabled', false)
        } else {
          $('#message_schedule_again').prop('checked', false)
          $('#message_schedule_again_date').prop('disabled', true)
          $('#message_schedule_again_time').prop('disabled', true)
        }

        $('#message_schedule').prop('checked', true)
        $('#message_schedule_date').prop('disabled', false)
        $('#message_schedule_time').prop('disabled', false)
      })
    } else {
      if (!$(cb_send).is(':checked') && action == 'edit') {
        $(confirmModal).modal('show')
        $(confirmModal).on('hidden.bs.modal', function () {
          $('#message_schedule_again').prop('checked', true)
          $('#content_send_again').removeClass('hidden')
        })
      }
    }
  }

  hideSchedule(scout_status) {
    if (scout_status) {
      $('#div_schedule').removeClass('hidden')
      if ($('#message_schedule_again').is(':checked')) {
        $('#content_send_again').removeClass('hidden')
      }
    } else {
      $('#div_schedule').addClass('hidden')
      $('#content_send_again').addClass('hidden')
    }
  }

  setScoutNewDefault(scout_id){
    $(document).ready(function(){
      $(`#is_high_class_${scout_id}`).trigger('click')
    })
  }
}

$(document).ready(function () {
  if ($('#message_schedule').is(':checked')) {
    addDatepicker('#message_schedule_date')
    addTimepicker('#message_schedule_time')
    $('#message_schedule_date').attr('readOnly', true)
    $('#message_schedule_time').attr('readOnly', true)
  } else {
    $('#message_schedule_date').prop('disabled', true)
    $('#message_schedule_time').attr('disabled', true)
  }

  if ($('#message_schedule_again').is(':checked')) {
    addDatepicker('#message_schedule_again_date')
    addTimepicker('#message_schedule_again_time')
    $('#message_schedule_again_date').attr('readOnly', true)
    $('#message_schedule_again_time').attr('readOnly', true)
    $('#content_send_again').removeClass('hidden')
    document.getElementById('message_body2').selectionEnd = document.getElementById('message_body2').value.length
  } else {
    $('#message_schedule_again_date').prop('disabled', true)
    $('#message_schedule_again_time').attr('disabled', true)
  }
})

function addDatepicker(elm) {
  $(elm).datepicker({
    dateFormat: 'yy年mm月dd日',
    minDate: new Date(),
    maxDate: new Date($(elm).attr('maximum_date'))
  })
}

function setDefaultDate(elm_date) {
  if (!$(elm_date).val()) {
    let current_date = new Date()
    $(elm_date).val(
      current_date.getFullYear() +
        '年' + ('0' + (current_date.getMonth() + 1)).slice(-2) + '月' + ('0' + current_date.getDate()).slice(-2) + '日'
    )
  }
}

function addTimepicker(elm) {
  $(elm).timepicker({
    template: 'dropdown',
    minuteStep: 15,
    showInputs: false,
    disableFocus: true,
    timeFormat: 'H:mm:ss p',
    icons: {
      up: 'fa fa-chevron-up',
      down: 'fa fa-chevron-down'
    }
  })
}
